export default __webpack_public_path__ + "static/media/filter.f91ffc8d.svg";